export default class Strings {
  private static strings: any = {
    default: {
      app_name: 'Free-Time',
      more_info: 'Детальніше',
      more_enterprises: 'Більше підприємств',
      google_play: 'https://play.google.com/store/apps/details?id=com.time.free.freetimeandroidclient'
    }
  };

  public static default ():object {
    return this.strings.default;
  }

  public static homePage ():object {
    return this.strings.homePage;
  }
}
